import { Pagination as AntdPagination } from 'antd';
import { PaginationProps as AntdPaginationProps } from 'antd/lib/pagination';

export type PaginationProps = AntdPaginationProps;

export const Pagination = AntdPagination;
export default Pagination;
